import { render, staticRenderFns } from "./screenCheques.vue?vue&type=template&id=6770f414"
import script from "./screenCheques.vue?vue&type=script&lang=js"
export * from "./screenCheques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports